import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../helpers/utility';

const initialState = {
  parkDetails: {},
  confDetails: {},
  error: null,
  loading: false,
};

// Call Park Status
const callStatusStart = (state, action) => {
  return updateObject(state, {loading: true});
};

const callStatusSuccess = (state, action) => {
  return updateObject(state, {
    parkDetails: action.parkDetails,
    confDetails: action.confDetails,
    loading: false,
    error: null,
  });
};
const callStatusFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
};

// Call Parking
const callParkStart = (state, action) => {
  return updateObject(state, {loading: true});
};

const callParkSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: null,
  });
};
const callParkFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
};

//Call Unparking

const callUnparkStart = (state, action) => {
  return updateObject(state, {loading: true});
};

const callUnParkSuccess = (state, action) => {
  return updateObject(state, {
    loading: false,
    error: null,
  });
};
const callUnParkFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CALL_STATUS_START:
      return callStatusStart(state, action);
    case actionTypes.CALL_STATUS_SUCCESS:
      return callStatusSuccess(state, action);
    case actionTypes.CALL_STATUS_FAIL:
      return callStatusFail(state, action);
    case actionTypes.CALL_PARK_START:
      return callParkStart(state, action);
     case actionTypes.CALL_PARK_SUCCESS:
      return callParkSuccess(state, action);
     case actionTypes.CALL_PARK_FAIL:
      return callParkFail(state, action);
     case actionTypes.CALL_UNPARK_START:
      return callUnparkStart(state, action);
     case actionTypes.CALL_UNPARK_SUCCESS:
      return callUnParkSuccess(state, action);  
     case actionTypes.CALL_UNPARK_FAIL:
      return callUnParkFail(state, action);          
    default:
      return state;
  }
};

export default reducer;
